// The dock's glass tint opacity (glass is only for the dock and scrims, decision
// 49), shared with the dock's contrast test (theme/dock-contrast.test.ts), which
// proves labels stay readable at exactly these values. High enough that content
// scrolling under the dock cannot bleed through the labels. Pure module: no React, importable in Jest.
export const GLASS_OVERLAY_ALPHA = { light: 0.88, dark: 0.88 } as const;
